import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { DarkModeContextProvider } from "./context/darkModeContext";
import {AuthContextProvider} from "./context/AuthContext";
import { Provider } from "react-redux";
import { store } from "../src/store/store";

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
      <AuthContextProvider>
    <DarkModeContextProvider>
      <App />
    </DarkModeContextProvider>
      </AuthContextProvider>
      </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
